__turbopack_context__.v({
  "accountMenuList": "NavigationBar-module__6DGKtG__accountMenuList",
  "bar": "NavigationBar-module__6DGKtG__bar",
  "inlineMenu": "NavigationBar-module__6DGKtG__inlineMenu",
  "menuIconButton": "NavigationBar-module__6DGKtG__menuIconButton" + " " + "NavigationBar-module__6DGKtG__navIconLink",
  "navIconLink": "NavigationBar-module__6DGKtG__navIconLink",
  "profileIndicatorBadge": "NavigationBar-module__6DGKtG__profileIndicatorBadge",
  "selected": "NavigationBar-module__6DGKtG__selected",
});
